import React from "react";
import Api from "utils/api";
import { colors } from "style/colors";
import styled from "styled-components";
import ModalEditor from "components/modal-editor";

const EmmaDisconnectModal = ({
  account,
  refresh,
  onSuccess,
  onError,
  ...rest
}) => {
  return (
    <ModalEditor
      {...rest}
      initialValues={{ confirm: "" }}
      saveLabel="Disconnect"
      validate={(value) => {
        let errors = {};
        if (value.confirm.toLowerCase() !== "i understand")
          errors.confirm = true;
        return errors;
      }}
      header="Disconnect Account"
      onSubmit={() =>
        Api.EMMA.ACCOUNT.delete({
          urlArgs: { id: account.id },
          data: { oid: account.oid },
        })
          .then(onSuccess)
          .then(refresh)
          .catch(onError)
      }
    >
      <WarningMessage>
        Disconnecting will not delete EverTrue lists or any Emma groups or
        contacts, however you won’t be able to send any lists from EverTrue to
        Emma.
      </WarningMessage>
      <WarningMessage>
        Please type “I Understand” to disconnect your account.
      </WarningMessage>
      <div
        style={{
          color: colors.errorDark,
          fontWeight: "500",
          marginBottom: "5px",
        }}
      >
        Note: This cannot be undone
      </div>
      <ModalEditor.FormField
        autoComplete="off"
        placeholder="I Understand"
        name="confirm"
      />
    </ModalEditor>
  );
};

const WarningMessage = styled.div`
  margin-bottom: 16px;
`;

export default EmmaDisconnectModal;
